import type {ReactElement} from 'react';
import React, {useEffect, useRef, useState} from 'react';
import './hex-picker.scss';
import {HexColorPicker, RgbaColorPicker} from '@postermywall/react-colorful';
import type {RGBA, Rgbacolor} from '@Utils/color.util';
import {rgbaToHex} from '@Utils/color.util';
import {hexToRgba} from '@Utils/color.util';
import {rgbacolorToRgba, rgbaToRgbacolor} from '@Utils/color.util';

interface HexPickerProps {
  className?: string;
  color: RGBA;
  isAlphaDisabled?: boolean;

  onChange(color: RGBA): void;

  onChangeEnded(color: RGBA): void;
}

export function HexPicker({className = '', isAlphaDisabled = false, ...props}: HexPickerProps): ReactElement<any> {
  const [isPointerDown, setIsPointerDown] = useState(false);
  const colorRef = useRef(props.color);
  const color = isAlphaDisabled ? rgbaToHex(props.color, false) : props.color;

  const onMouseUp = (): void => {
    props.onChangeEnded(colorRef.current);
    window.removeEventListener('pointerup', onMouseUp);
    setIsPointerDown(false);
  };

  useEffect(() => {
    if (isPointerDown) {
      window.addEventListener('pointerup', onMouseUp);
    }
    return (): void => {
      window.removeEventListener('pointerup', onMouseUp);
    };
  }, [isPointerDown]);

  return (
    <div className={`${className} saturation`}>
      {isAlphaDisabled ? (
        <HexColorPicker
          color={color as string}
          onChange={(value: string): void => {
            props.onChange(hexToRgba(value));
            colorRef.current = hexToRgba(value);
          }}
          onPointerDown={(): void => {
            setIsPointerDown(true);
          }}
        />
      ) : (
        <RgbaColorPicker
          color={rgbaToRgbacolor(color as RGBA)}
          onChange={(value: Rgbacolor): void => {
            const color = rgbacolorToRgba(value);
            props.onChange(color);
            colorRef.current = color;
          }}
          onPointerDown={(): void => {
            setIsPointerDown(true);
          }}
        />
      )}
    </div>
  );
}
